import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBladeSize } from '../../../helpers/bladeSize';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { BaseProduct, ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  bladeSize: string,
  colour: string,
  products: BaseProduct[],
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (bladeSize, colour, products, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      bladeSize,
    },
  });
}

export const BladeSize = () => {
  const [state, send] = useService(productBuilderMachine);
  const { 
    products,
    custom: {
      bladeSize,
      colour
    }
   } = state.context;
  const productType = getBaseProductType(state.context);
  const bladeSizeOptions = getBladeSize(state.context);

  if (isCurrentState('bladeSize', state) && bladeSizeOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Blade Size</Heading>
      <Selector isSlider={true}>
        {bladeSizeOptions.map(option => {
          const isSelected = option === bladeSize;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'bladeSize',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(option, colour, products, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
